document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-close-details]').forEach((button) => {
    button.addEventListener('click', () => {
      const details = button.closest('details');
      if (details) details.removeAttribute('open');
    });
  });

  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('drawer-open', menu.open);
    });
  });

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-address-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.addressToggle);
      if (target) target.hidden = !target.hidden;
    });
  });
});
